import { render, staticRenderFns } from "./searchHeaderView.vue?vue&type=template&id=b12192f0&scoped=true"
import script from "./searchHeaderView.vue?vue&type=script&lang=js"
export * from "./searchHeaderView.vue?vue&type=script&lang=js"
import style0 from "./searchHeaderView.vue?vue&type=style&index=0&id=b12192f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12192f0",
  null
  
)

export default component.exports